import { defineComponent as _defineComponent } from 'vue'
import {
  BankAccount as BankAccountType,
} from "@/model/BankAccount";

import {
  computed,
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import {
  useI18n,
} from "@/composables/useI18n";

import type {
  BankAccount,
} from "@/scripts/Common";

import VueI18n from "vue-i18n";

import {
  isStringAndHasLength,
  isValidBic,
  isValidIban,
} from "@/scripts/Common/validators/defaultValidator";

import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import {
  countCharacterSepaField,
  formatDate,
  getInvalidCharacters,
} from "@/scripts/Common/helpers";

import {
  hasSepaCondition,
  hasSepaCreditorIdCondition,
  hasValidLengthOnSepaCondition,
} from "@/scripts/Common/validators";

import {
  SEPA_CHARACTER_REPLACER_REGEX,
} from "@/scripts/Constants";

import {
  validateCreditorIdChecksum,
} from "@/scripts/Common/bankAccount";
import {InformationCard} from "@/components/children";


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountEdit',
  props: {
  label: {
    required: true,
    type: String as PropType<string | VueI18n.TranslateResult>,
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  model: {
    required: true,
    type: Object as PropType<BankAccount | BankAccountType>
  },
  optionalIfEmpty: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  creditorId: {
    required: false,
    type: String as PropType<string>,
    default: ""
  },
  isCreditorIdRequired: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  showCreditorId: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  sepaSddMandatorReference: {
    required: false,
    type: String as PropType<string>,
    default: ""
  },
  sepaSddSignatureDate: {
    required: false,
    type: String as PropType<string>,
    default: ""
  },
  showSepaSdd: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  isSepaSddRequired: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
  expanded: {
    required: false,
    type: Array as PropType<number[]>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'ValidChanged',
  'update:sepaSddSignatureDate',
  'update:sepaSddMandatorReference',
  'update:creditorId'
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();





const valid = ref(true);
const form = ref();

const creditorIdErrorMessage = ref<string>();
const showCreditorIdInformationCard = ref(false);
const showIbanInformationCard = ref(false);
const isValidatingCreditorId = ref(false);

const isOptional = computed( () => {
  return props.optionalIfEmpty && props.model?.isModelEmpty()
});

const internalExpand = ref(props.expanded);

const validationConstraints = {
  creditInstituteCharacterLength: 80,
  ibanCharacterLength: 22,
  bicCharacterLength: 11,
  nameCharacterLength: 70,
  creditorIdCharacterLength: 18,
  sepaMandatorReferenceCharacterLength: 35
};

const validateCreditorChecksum = async (value: string) => {
  creditorIdErrorMessage.value = undefined;
  if(!value) return;

  if(!hasSepaCreditorIdCondition(value)) return;

  isValidatingCreditorId.value = true;
  const { error } = await validateCreditorIdChecksum(value);
  isValidatingCreditorId.value = false;

  if(error){
    creditorIdErrorMessage.value = t('checksum_invalid');
    return;
  }
}

const validate = () => {
  if(form.value === undefined) return;
  (form.value as any).validate();
}

watch(() => props.creditorId, () => validateCreditorChecksum(props.creditorId))

watch(valid, () => {
  validate();
  emits('ValidChanged', unref(valid));
})

watch(() => props.optionalIfEmpty, () => {
  validate();
})

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded
})

return { __sfc: true,t, props, emits, valid, form, creditorIdErrorMessage, showCreditorIdInformationCard, showIbanInformationCard, isValidatingCreditorId, isOptional, internalExpand, validationConstraints, validateCreditorChecksum, validate, isStringAndHasLength, isValidBic, isValidIban, DateFormats, countCharacterSepaField, formatDate, getInvalidCharacters, hasSepaCondition, hasSepaCreditorIdCondition, hasValidLengthOnSepaCondition, SEPA_CHARACTER_REPLACER_REGEX, InformationCard }
}

})